<template>
  <div id="experience-collections">
    <div v-if="isPhone" class="d-flex flex-column align-items-center justify-content-center">
      <div :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'">Une sélection pensée</div>
      <div :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'">pour chaque envie</div>
      <p :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'" class="text-center">Des expériences multiples, pour des <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">souvenirs uniques</span></p>
    </div>
    <div class="">
      <div class="row row-hubs">
        <div class="col-12 d-flex justify-content-center align-items-center w-100">
          <div class="lodging-header w-100">
            <div class="header-nav">
              <div v-for="collection in collections.slice(0,3)" :key="collection" class="header-nav-tabs">
                <div class="raleway-bold-p15 text-uppercase" 
                    :class="{ activeCard: selectedCollection === collection }" 
                    @click="selectedCollection = collection" 
                    :data-value="collection">
                  {{ collection }}
                </div>
              </div>

              <div v-if="!isPhone" class="d-flex flex-column align-items-center justify-content-center">
                <div :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'">Une sélection pensée</div>
                <div :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'">pour chaque envie</div>
                <p :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'" class="text-center">Des expériences multiples, pour des <span class="merriweather-light-italic-24">souvenirs uniques</span></p>
              </div>

              <div v-for="collection in collections.slice(3,6)" :key="collection" class="header-nav-tabs">
                <div class="raleway-bold-p15 text-uppercase" 
                    :class="{ activeCard: selectedCollection === collection }" 
                    @click="selectedCollection = collection" 
                    :data-value="collection">
                  {{ collection }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid position-relative">
          <div class="d-flex flex-row flex-nowrap" ref="scroller" style="overflow: scroll; overflow-y: hidden">
            <div class="card card-body border-0" v-if="lodgings"  v-for="lodging in lodgings" :key="`${selectedCollection}-${lodging.id}`" style="min-height: auto; min-width: auto; margin-right:25px; max-width: 334px;">
              <CardProductHome :user="user || {}" data-aos="fade-up" data-aos-duration="900" :lodging="lodging"></CardProductHome>
            </div>
          </div>
          <div class="flex-shrink-0 previous-slide-button circle-icon" @click="scroll_left">
            <img src="../../images/arrow-left-black.svg" alt="Previous" />
          </div>
          <div class="flex-shrink-0 next-slide-button circle-icon"@click="scroll_right">
            <img src="../../images/arrow-right-black.svg" alt="Next" />
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex align-items-center justify-content-center" :class="isPhone ? 'px-5 mt-2' : ' mt-5'">
      <a class="hortense-btn-primary raleway-bold-p" :href="redirectionLink || '/les-nouveautes-hortense'" target="_blank">DÉCOUVRIR NOTRE SÉLECTION</a>
    </div>
  </div>
</template>

<script>
import CardProductHome from "../../components/cards/CardProductHome.vue";
import AOS from "aos";
import fetcher from "../../packs/shared/api.js";

export default {
  name: 'ExperienceCollections',
  components: { CardProductHome },
  props: ['user', 'redirectionLink'],
  data() {
    return {
      isPhone: window.innerWidth <= 768,
      lodgings: [],
      collections: ['Romantique', 'Bien-etre', 'Famille', 'Insolite', 'City Break', 'Nature'],
      selectedCollection: null,
      collectionsSlugs: {
        'Romantique': 'sejour-romantique',
        'Bien-etre': 'sejour-spa',
        'Famille': 'sejour-en-famille',
        'Insolite': 'sejour-insolite',
        'City Break': 'city-break',
        'Nature': 'sejour-nature'
      }
    };
  },
  mounted() {
    this.fetchHomeLoadings();
    AOS.init();
    this.autoScroll();
  },
  methods: {
    async fetchHomeLoadings() {
      const responseAccommodation = await fetcher.get(
          "/home_lodgings", {
            params: { collection: this.collectionsSlugs[this.selectedCollection] }
          }
        );
      this.lodgings = responseAccommodation.data;
    },
    autoScroll() {
      const scroller = this.$refs.scroller;
      const step = 1; // Adjust step for speed
      let maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

      const frame = () => {
        if (scroller.scrollLeft >= maxScrollLeft) {
          scroller.scrollLeft = 0; // Reset scroll to start when it reaches the end
          maxScrollLeft = scroller.scrollWidth - scroller.clientWidth; // Recalculate in case of dynamic content
        } else {
          scroller.scrollLeft += step;
        }
        requestAnimationFrame(frame);
      }
      frame();
    },
    scroll_left() {
      this.$refs.scroller.scrollLeft -= 220;
    },
    scroll_right() {
      this.$refs.scroller.scrollLeft += 220;
    }
  },
  watch: {
    selectedCollection() {
      this.fetchHomeLoadings();
    }
  }
};
</script>

<style scoped>
#experience-collections {
  .header-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    gap: 40px;

    @media screen and (max-width: 767px) {
      gap: 15px;
      overflow-x: auto;
      align-items: start;
      justify-content: start;
    }

    .header-nav-tabs {
      cursor: pointer;
      color: #524F4FDD;

      div {
        white-space: nowrap;
        padding: 0.5rem 1rem;

        @media screen and (max-width: 767px) {
          padding: 0.5rem 0.5rem 0.5rem 0px;
        }
      }
    }
    .activeCard {
      font-weight: 800;
      color: black;
      border-bottom: 2px solid #3B6152;
    }
  }

  .hub-img, .hub-img-zoom {
    width: 334px !important;
    height: 277px !important;
  }
}

.circle-icon {
  width: 44px;
  height: 46px;
  border: 1px solid #F7F7F7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media screen and (max-width: 767px) {
    width: 35px;
    height: 35px;
    img {
      width: 20px;
    }
    
  }
}
.previous-slide-button {
  position: absolute;
  top: 30%;
  transform: translateY(-50%);
  left: 15px;
  color: #F7F7F7;
  background-color: #F7F7F7;

  i {
    color: black;
  }
}

.next-slide-button {
  position: absolute;
  top: 30%;
  transform: translateY(-50%);
  right: 15px;
  color: #F7F7F7;
  background-color: #F7F7F7;

  i {
    color: black;
  }
}
</style>